var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { PureComponent } from 'react';
import { services } from '@comall-backend-builder/core';
/**
 * 文本组件，text 属性支持使用 {{}} 表达式从 props 进行插值
 */

var Text = function (_super) {
  __extends(Text, _super);

  function Text() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Text.prototype.render = function () {
    var _a = this.props,
        style = _a.style,
        text = _a.text,
        className = _a.className;
    var result = services.interpolate(text, this.props);
    return React.createElement("span", {
      style: style,
      className: className
    }, result);
  };

  return Text;
}(PureComponent);

export { Text };